import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { track } from '../utils/track';
type CtaButtonProps = {
  children: React.ReactNode;
  href?: string;
  className?: string;
  size?: 'lg' | 'sm';
  /** 'onDark' inverts the button for use on ink backgrounds. */
  variant?: 'default' | 'onDark';
  /** Fires InitiateCheckout when this button leads to the checkout. */
  isCheckout?: boolean;
};
export function CtaButton({
  children,
  href = '#pricing',
  className = '',
  size = 'lg',
  variant = 'default',
  isCheckout = false
}: CtaButtonProps) {
  const sizing = size === 'lg' ? 'px-8 py-4 text-base sm:text-[17px]' : 'px-6 py-3 text-sm';

  // Ink text on the CTA green: white on #25D366 fails contrast.
  const palette = variant === 'onDark' ? 'bg-cta text-ink hover:bg-cta-dark focus-visible:ring-white focus-visible:ring-offset-ink' : 'bg-cta text-ink hover:bg-cta-dark focus-visible:ring-cta-dark focus-visible:ring-offset-ivory';
  return <a href={href} onClick={isCheckout ? () => track('InitiateCheckout') : undefined} className={`group inline-flex items-center justify-center gap-2 rounded font-semibold tracking-wide shadow-card transition-[background-color,box-shadow,transform] duration-150 ease-out hover:shadow-lift focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 ${palette} ${sizing} ${className}`} data-id="element-79" data-mp="35xfol80977at">
      {children}
      <ArrowRightIcon className="w-[18px] h-[18px] transition-transform duration-150 ease-out group-hover:translate-x-0.5" aria-hidden="true" data-id="element-80" data-mp="3ov8qq831zd75" />
    </a>;
}